module.exports = __webpack_public_path__ + "img/event_1_cover.f9caf52a.jpg";